import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Customers_Duplicates_Object} state
 *  @property {object} model
 *  @property {Customers_Duplicates_Properties} model.properties
 *  @property {Customers_Duplicates_Is} model.is
 *  @property {Customers_Duplicates_Has} model.has
 */
export default class CustomerCompareObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Customers_Duplicates._name);
		if( this.props.type === 'pending' ) {
			this.read = 'GET_PENDING';
			this.update = 'POST_PENDING';
		} else {
			this.read = 'GET';
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if( this.props.type === 'pending' ) {
			this.read = 'GET_PENDING';
			this.update = 'POST_PENDING';
		} else {
			this.read = 'GET';
		}
	}

	/**
	 * @param {Customers_Duplicates_Object} data
	 */
	loadSelfAfter = (data) => {
		// noinspection JSValidateTypes
		/** @type {Customers_Duplicates_Object} stateUpdate */
		let stateUpdate = {};
		if (data.customer_addressess && data.customer_addressess.length > 0) {
			// noinspection JSValidateTypes
			/** @type {Customers_Addresses_Object} address */
			let address = data.customer_addressess[0];
			stateUpdate.street_1 = address.street_1;
			stateUpdate.street_2 = address.street_2;
			stateUpdate.city = address.city;
			stateUpdate.county = address.county;
			stateUpdate.state = address.state;
			stateUpdate.zip = address.zip;
		}
		if (data.customer_emailss && data.customer_emailss.length > 0) {
			// noinspection JSValidateTypes
			/** @type {Customers_Emails_Object} email */
			let email = data.customer_emailss[0];
			stateUpdate.email = email.email;
		}
		if (data.customer_numberss && data.customer_numberss.length > 0) {
			// noinspection JSValidateTypes
			/** @type {Customers_Numbers_Object} number */
			let number = data.customer_numberss[0];
			// noinspection JSValidateTypes
			stateUpdate.phone = number.number;
		}

		// noinspection JSUnresolvedVariable
		if (data.originals) {
			// noinspection JSValidateTypes
			if( this.props.type === 'pending' ) {
				/** @type {Dispositions_Pendings_Object} original */
				let original = data.originals;
				stateUpdate.original_name_first = original.name_first;
				stateUpdate.original_name_middle = original.name_middle;
				stateUpdate.original_name_last = original.name_last;

				stateUpdate.original_street_1 = original.street_1;
				stateUpdate.original_street_2 = original.street_2;
				stateUpdate.original_city = original.city;
				stateUpdate.original_county = original.county;
				stateUpdate.original_state = original.state;
				stateUpdate.original_zip = original.zip;

				stateUpdate.original_email = original.email;

				stateUpdate.original_phone = original.number;
			} else {
				/** @type {Customers_Object} original */
				let original = data.originals;

				stateUpdate.original_name_first = original.name_first;
				stateUpdate.original_name_middle = original.name_middle;
				stateUpdate.original_name_last = original.name_last;
				if (original.customer_addressess.length > 0) {
					// noinspection JSValidateTypes
					/** @type {Customers_Addresses_Object} address */
					let address = original.customer_addressess[0];
					stateUpdate.original_street_1 = address.street_1;
					stateUpdate.original_street_2 = address.street_2;
					stateUpdate.original_city = address.city;
					stateUpdate.original_county = address.county;
					stateUpdate.original_state = address.state;
					stateUpdate.original_zip = address.zip;
				}
				if (original.customer_emailss.length > 0) {
					// noinspection JSValidateTypes
					/** @type {Customers_Emails_Object} email */
					let email = original.customer_emailss[0];
					stateUpdate.original_email = email.email;
				}
				if (original.customer_numberss.length > 0) {
					// noinspection JSValidateTypes
					/** @type {Customers_Numbers_Object} number */
					let number = original.customer_numberss[0];
					// noinspection JSValidateTypes
					stateUpdate.original_phone = number.number;
				}
			}
		}

		this.setState(stateUpdate);
	};

	async handleSubmit(event, suppressToast = false, suppressProcess = false) {
		if( this.props.type === 'pending' ) {
			this.update = 'POST_PENDING';
		} else {
			this.update = 'POST';
		}
		await super.handleSubmit(event, suppressToast, suppressProcess);
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		if( this.props.type === 'pending' ) {
			if( this.props.handleTabChange ) {
				this.props.handleTabChange(null, 'details');
			} else {
				this.props.history.push('/dispositions/pendings/' + this.props.parent + '#details');
			}
		} else {
			this.props.history.push('/customers/' + data.binary_id + "-" + data.pkey + '#details');
		}
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Customers_Duplicates_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Duplicates_Object} object */
		let object = this.state;

		return (
			<div>
				<div className={"row"}>
					<div className={"col-md"}>
						<h4 className="section-title">Customer (Current)</h4>
						<fieldset disabled={true}>
							<Parts.CustomerName
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								prefix={'original_'}
							/>

							<h4 className="section-title">Contact Information</h4>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									label={'Phone'}
									property={properties.original_phone}
									value={object.original_phone}
									error={object.original_phone_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									label={'Email'}
									property={properties.original_email}
									value={object.original_email}
									error={object.original_email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className={"form-group"}>
								<h4 className="section-title">Address</h4>
								<Parts.Address
									object={object}
									properties={properties}
									onTextUpdate={this.handleTextFieldPropertyUpdate}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									prefix={'original_'}
								/>
							</div>
						</fieldset>
					</div>
					<div className={"col-md"}>
						<div className="section-title">
							<h4 className="section-title">Customer (Possible Duplicate)</h4>
							<a href={'/customers/' + object.binary_id + '-' + object.pkey + '#details'}><Button color="info">View</Button></a>
						</div>
						<fieldset disabled={true}>
							<Parts.CustomerName
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
							/>

							<h4 className="section-title">Contact Information</h4>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									property={properties.phone}
									value={object.phone}
									error={object.phone_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className={"form-group"}>
								<h4 className="section-title">Address</h4>
								<Parts.Address
									object={object}
									properties={properties}
									onTextUpdate={this.handleTextFieldPropertyUpdate}
									onSelectUpdate={this.handleSelectPropertyUpdate}
								/>
							</div>
						</fieldset>
					</div>
					<div className={"row"}>
						<div className={"form-group"} style={{padding: "5px", width: "800px", position: "relative", left: "12px"}}>
							<p align={"center"}>Merging customers will save the information from the one with the most
								recent transaction. All past transaction will be reassigned to the correct customer entry. <b>This
									WILL NOT change bound book entries, acquisitions, or dispositions.</b> If changes are required
								to customers information, they must be made directly to the transaction. Merging duplicate customers
								will help ensure accurate Multiple Sale reports.
							</p>
						</div>
					</div>
				</div>

			</div>
		)
	}
}
